module.exports = __webpack_public_path__ + "fromBrideToParents-we-p.4cc0f0a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-p.jpg
// module id = HXpV
// module chunks = 0